import { applyMiddleware, createStore } from "redux";
import { rootReducer } from "./reducer";
import { thunk } from "redux-thunk";

//const logger = createLogger();
//const middleware = applyMiddleware(thunk, logger);
const middleware = applyMiddleware(thunk);

export const store = createStore(rootReducer, middleware);
